import React, { useState, useEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import axios from "axios";

const PreCounter = (props) => {
  const { t } = useTranslation();
  let link = localStorage.getItem("link");
  const activeRights = JSON.parse(localStorage.getItem("rights"));

  const [preCounterData, setPreCounterData] = useState([]);
  const allRefs = useRef([]);
  const allPreCounter = useRef();

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  function getPreCounter() {
    axios
      .get(link + "/api/PreCounter", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setPreCounterData(response.data);
      })
      .catch((error) => {});
  }

  useEffect(() => {
    getPreCounter();
  }, []);

  function editPreCounter(elementId, value) {
    const data = [
      {
        elementId: elementId,
        delay: parseInt(value),
      },
    ];

    axios
      .put(link + "/api/PreCounter/ResetDelay", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setTimeout(getPreCounter, 1500);
      })
      .catch((error) => {});
  }

  function editAllPreCounter(value) {
    axios
      .put(link + "/api/PreCounter/ResetDelayAll?delay=" + parseInt(value), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setTimeout(getPreCounter, 1500);
      })

      .catch((error) => {});
  }

  return (
    <div className="einstellungen-box">
      <div className="box-name"> {t("administration.preCounterSettings")}</div>
      <div style={{ overflow: "auto" }}>
        <table id="preCounterTable">
          <thead>
            <th style={{ textAlign: "center" }}>{t("allgemein.name")}</th>
            <th style={{ textAlign: "center" }}>
              {t("administration.preCounter.timeoutAktuell")}
            </th>
            <th style={{ textAlign: "center" }}>
              {t("administration.preCounter.timeoutNeu")}
            </th>
            <th style={{ textAlign: "center" }}></th>
          </thead>
          <tbody>
            {preCounterData.map((item, i) => (
              <tr>
                <td>{item.name}</td>
                <td>
                  {item.resetDelayTimeInSeconds} {t("allgemein.sekundenKurz")}
                </td>
                <td>
                  <input
                    type="number"
                    min="0"
                    style={{ width: "50px", marginRight: "5px" }}
                    ref={(ref) => allRefs.current.push(ref)}
                  />
                  {t("allgemein.sekundenKurz")}
                </td>
                <td>
                  {activeRights.includes("PreCounter.ResetDelay") && (
                    <button
                      class="button"
                      onClick={() =>
                        editPreCounter(item.id, allRefs.current[i].value)
                      }
                    >
                      {t("allgemein.senden")}
                    </button>
                  )}
                </td>
              </tr>
            ))}
            <tr>
              <td>{t("administration.preCounter.allePrecounter")}</td>
              <td></td>
              <td>
                <input
                  type="number"
                  min="0"
                  style={{ width: "50px", marginRight: "5px" }}
                  ref={allPreCounter}
                />
                {t("allgemein.sekundenKurz")}
              </td>
              <td>
                {activeRights.includes("PreCounter.ResetDelay") && (
                  <button
                    class="button"
                    onClick={() =>
                      editAllPreCounter(allPreCounter.current.value)
                    }
                  >
                    {t("allgemein.senden")}
                  </button>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreCounter;
